import { createSlice } from "@reduxjs/toolkit";
import { logout } from "../../auth/authSlice";
import { FIELD_STATUS_ALL_CLASSIFICATIONS } from "../../../../utils/fieldDataDiseaseStatusUtils";

const initialState = {
  data: {
    dates: [],
    latestDate: null,
    startTime: null,
    endTime: null,
    selectedClassification: FIELD_STATUS_ALL_CLASSIFICATIONS,
    images: [],
    classificationCounts: {},
    fieldFilter: null,
  },
  detailsById: {},
  detailsLoadingById: {},
  detailErrorsById: {},
  isLoading: false,
  error: null,
};

const diseaseStatusSlice = createSlice({
  name: "diseaseStatus",
  initialState,
  reducers: {
    fetchDiseaseStatusStart(state, action) {
      state.isLoading = true;
      state.error = null;
      state.data = {
        ...initialState.data,
        classificationCounts: state.data.classificationCounts,
        selectedClassification:
          action.payload?.classification || FIELD_STATUS_ALL_CLASSIFICATIONS,
        fieldFilter:
          action.payload?.fieldFilters?.[0] ||
          (action.payload?.fieldUuid
            ? { field_uuid: action.payload.fieldUuid }
            : null),
      };
    },
    fetchDiseaseStatusSuccess(state, action) {
      state.isLoading = false;
      state.error = null;
      state.data = action.payload;
    },
    fetchDiseaseStatusFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.data = initialState.data;
    },
    fetchDiseaseStatusImageDetailStart(state, action) {
      const imageId = action.payload?.imageId;

      if (!imageId) {
        return;
      }

      state.detailsLoadingById[imageId] = true;
      state.detailErrorsById[imageId] = null;
    },
    fetchDiseaseStatusImageDetailSuccess(state, action) {
      const { imageId, detail } = action.payload;

      state.detailsLoadingById[imageId] = false;
      state.detailErrorsById[imageId] = null;
      state.detailsById[imageId] = detail;
    },
    fetchDiseaseStatusImageDetailFailure(state, action) {
      const { imageId, error } = action.payload;

      if (!imageId) {
        return;
      }

      state.detailsLoadingById[imageId] = false;
      state.detailErrorsById[imageId] = error;
    },
    resetDiseaseStatusState() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState);
  },
});

export const {
  fetchDiseaseStatusStart,
  fetchDiseaseStatusSuccess,
  fetchDiseaseStatusFailure,
  fetchDiseaseStatusImageDetailStart,
  fetchDiseaseStatusImageDetailSuccess,
  fetchDiseaseStatusImageDetailFailure,
  resetDiseaseStatusState,
} = diseaseStatusSlice.actions;

export default diseaseStatusSlice.reducer;
